<script lang="ts" setup>
import type {SynchroHistory} from "@/domain/type/synchro.type.ts";

defineProps<{
  source: string,
  history: SynchroHistory[]
}>()
defineEmits(['close'])

const headers = [
  {title: 'Date', align: 'start', sortable: false, key: 'dateChg'},
  {title: 'Source', align: 'start', sortable: false, key: 'src'},
  {title: 'Champ', align: 'start', sortable: false, key: 'label'},
  {title: 'Ancienne valeur', align: 'start', sortable: false, key: 'oldValue', maxWidth: '400px'},
  {title: 'Nouvelle valeur', align: 'start', sortable: false, key: 'newValue', maxWidth: '400px'},
  {title: 'Appliqué par', align: 'start', sortable: false, key: 'applyBy'},
]

function filterText(text: string): string
{
  return text.replace(/&nbsp;/gi,' ')
}
</script>

<template>
  <v-card class="sourceHistoryCard" rounded="lg">
    <v-card-title class="d-flex justify-space-between align-center">
      <div>
        Historique de synchronisation {{ source }}
      </div>
      <v-btn
        color="grey"
        icon="mdi-close"
        rounded="true"
        variant="text"
        @click="$emit('close')"
      />
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="history"
        class="historyTable"
        hide-default-footer
        item-key="label"
        no-data-text="Aucun historique"
      >
        <template v-slot:item="{item}">
          <tr>
            <td>
            <span class="font-weight-bold">
              {{
                new Date(item.dateChg).toLocaleDateString() + ' ' + new Date(item.dateChg).toLocaleTimeString(Intl.getCanonicalLocales()[0], {
                  hour: '2-digit',
                  minute: '2-digit'
                })
              }}
            </span>
            </td>
            <td>
              {{ item.src }}
            </td>
            <td>
              {{ item.label }}
            </td>
            <td>
              {{ filterText(item.oldValue) }}
            </td>
            <td>
              {{ filterText(item.newValue) }}
            </td>
            <td>
              {{ item.applyBy }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>
